import { enHero } from '../en';
import { frHero } from '../fr';
import { esHero } from '../es';
import { deHero } from '../de';

export const heroModuleTranslations = {
  en: enHero,
  fr: frHero,
  es: esHero,
  de: deHero,
} as const;

